import React, { useState } from 'react';
import { Button, Link, Stack } from '@hover/blueprint';
import { ArrowButton, DownloadAppModal } from '@hover/shared-components';
import { useMediaQuery } from '@chakra-ui/react';
import { navigate } from 'gatsby';
import { URLS } from '../../constants';
import { useABTesting } from '../../hooks';
import { ctaABTesting } from '../../utils/ctaABTesting';

const HeroButtons: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isDesktop] = useMediaQuery('(min-width: 1280px)');
  const abTestValue = useABTesting({
    testName: 'how-to-measure-roof-hero-cta-pressed',
  });

  if (!abTestValue) return <>Loading...</>;

  const toggleModal = () => {
    if (!isDesktop) setIsOpen(!isOpen);
    else if (abTestValue === 'A') {
      ctaABTesting('A');
      setIsOpen(!isOpen);
    } else {
      ctaABTesting('B');
      void navigate('/signup');
    }
  };

  return (
    <Stack
      w={{ base: '100%', tablet: 'auto' }}
      direction={{ base: 'column', tablet: 'row' }}
      spacing={{ base: 400, tablet: 500 }}
    >
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Button
        onClick={toggleModal}
        size="large"
        w={{ base: '100%', tablet: 'auto' }}
        textTransform="uppercase"
      >
        start free trial
      </Button>
      <ArrowButton
        as={Link}
        href={URLS.howToMeasureRoof.chatWithUs}
        variant="minimal"
        w={{ base: '100%', tablet: 'auto' }}
        sx={{
          // TODO(buttons): remove when we remove padding in Blueprint
          div: { pl: 0, pr: 50 },
        }}
      >
        Chat with us
      </ArrowButton>
    </Stack>
  );
};

export default HeroButtons;
